const COLORS = {
  uncertainty: '#aaaaaa',
  // '#2ec7c9',
  // '#b6a2de',
  customer: '#5ab1ef',
  vision: '#ffb980',
  // '#d87a80',
  // '#8d98b3',
  // '#e5cf0d',
  operations: '#97b552',
  // '#95706d',
  // '#dc69aa',
  // '#07a2a4',
  // '#9a7fd1',
  total_capacity: '#588dd5',
  // '#f5994e',
  // '#c05050',
  initiatives: '#59678c',
  flow_capacity: '#c9ab00',
  // '#7eb00a',
  // '#6f5553',
  // '#c14089',
};
export default COLORS;
